const regex = /%TAG_(.*?)%/gi;

export const getObjectTags = (policy) => {
  let match = null;
  const tagNames = [];

  while ((match = regex.exec(policy.objeto)) != null) {
    const tagName = match[1].trim();
    !tagNames.includes(tagName) && tagNames.push(tagName);
  }

  return tagNames.map((tagName) => ({
    label: tagName,
    id: tagName.replace(".", ""),
    value: "",
  }));
};

export const setObject = (policy) => {
  policy.objeto = policy.objeto.replace(regex, (match, p1) => {
    return `<span class="font-weight-bold proposta__tag-text ${getClassName(
      p1
    )}">[${p1.trim()}]</span>`;
  });
};

export const getClassName = (text) => {
  const symbolRegex = /\/|\.|\(|\)/gi;
  const spaceRegex = /\s/gi;
  return text.replace(symbolRegex, "").replace(spaceRegex, "_");
};

export const updateObjectWithTagValues = (policy) => {
  policy.objeto_tags.forEach((tag) => {
    policy.objeto = policy.objeto.replaceAll(`[${tag.id}]`, tag.value);
  });
};

export const updatePlaceholderContent = (tag) => {
  const id = getClassName(tag.id);
  const els = document.querySelectorAll("." + id);
  els.forEach((el) => {
    el.innerHTML = tag.value || `[${tag.id}]`;
  });
};

export const prepareObjetoText = (objeto) => {
  // Remove as tags html
  let objetoWithoutHTMLTags = objeto.replace(/(<([^>]+)>)/gi, "");
  return "[%j%]" + objetoWithoutHTMLTags + "[%/j%]";
};



// WEBPACK FOOTER //
// ./src/libs/objectTags.js